export default function validate(values) {
  const { username, password } = values;

  let validateUsername = !username && 'Email harus diisi';

  if (username) {
    const emailValidation =
      username && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(username)
        ? 'Format penulisan email salah'
        : undefined;
    validateUsername = emailValidation;
  }

  return {
    username: validateUsername,
    password: !password && 'Kata Sandi harus diisi',
  };
}
